import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretLeft = () => {
  return (
    <g>
      <path d="M12 13.254a.695.695 0 0 1-.26.526c-.316.267-.81.29-1.158.073l-.1-.073L4.26 8.53l-.086-.084a.66.66 0 0 1 .007-.901l.08-.076 6.217-5.248.1-.073a1.024 1.024 0 0 1 1.058 0l.1.073.085.084c.117.132.175.29.175.446L12 13.254z" />
    </g>
  );
};

export default withIcon(IconCaretLeft);
